var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axiosInstance from '../../store/AxiosSingleton';
import { ForumMessage } from 'forum/classes/ForumMessage.class';
import { Sujet } from 'forum/classes/Sujet.class';
import { Thematique } from 'forum/classes/Thematique.class';
import { ThematiqueData } from 'forum/classes/ThematiqueData.class';
export class ForumService {
    /**
     * Charge les thématiques et les sujets associés
     */
    static loadThematique() {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: ForumService.rubModule,
                    action: 'LOAD_THEMATIQUE',
                },
            });
            return content.map((rep) => ({
                thematique: new Thematique(rep.thematique),
                sujet: new Sujet(rep.sujet),
            }));
        });
    }
    /**
     * Charge les sujets d'une thématique
     * @param filter Filtres à appliquer
     * @return Sujets récupérés
     */
    static loadSujets(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: ForumService.rubModule, action: 'LOAD_SUJETS' }, filter),
            });
            return content.map((maReponse) => ({
                sujet: new Sujet(maReponse.sujet),
                dernierMessage: new ForumMessage(maReponse.dernierMessage),
            }));
        });
    }
    /**
     * Charge les messages d'un sujet
     * @param filter Filtres à appliquer
     * @return Messages récupérés
     */
    static loadMessagesSujet(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: ForumService.rubModule, action: 'LOAD_MESSAGES_SUJET' }, filter),
            });
            return {
                messages: content.messages.map((message) => new ForumMessage(message)),
                sujet: new Sujet(content.sujet),
                isFollow: content.isFollow,
                firstMessage: new ForumMessage(content.firstMessage),
            };
        });
    }
    /**
     * Charge un sujet à partir de son identifiant
     * @param idSujet Identifiant du sujet
     * @return Le sujet trouvé
     */
    static getSujet(idSujet) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: {
                    rub: ForumService.rubModule,
                    action: 'GET_SUJET',
                    idSujet,
                },
            });
            return new Sujet(content);
        });
    }
    /**
     * Récupère les données d'une thématique
     * @param filter Filtres à appliquer
     * @return Données de la thématique
     */
    static loadThematiqueData(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.get('/index.php', {
                params: Object.assign({ rub: ForumService.rubModule, action: 'LOAD_THEMATIQUE_DATA' }, filter),
            });
            return new ThematiqueData(content);
        });
    }
    /**
     * Ajout d'un sujet à une thématique
     * @param sujet Sujet à insérer
     * @return Si action réussie renvoie l'identifiant du sujet inséré, sinon null
     */
    static addSujet(sujet) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                sujet: sujet.toRaw(),
            }, {
                params: {
                    rub: ForumService.rubModule,
                    action: 'SAVE_SUJET',
                },
            });
            return content;
        });
    }
    /**
     * Déplacement d'un sujet dans une autre thématique
     * @param idSujet Identifiant du sujet à déplacer
     * @param idThematique Identifiant de la thématique de destination
     * @return Succès de l'opération
     */
    static moveSubject(idSujet, idThematique) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idSujet, idThematique }, {
                params: {
                    rub: ForumService.rubModule,
                    action: 'MOVE_SUBJECT',
                },
            });
            return content;
        });
    }
    /**
     * Suppression d'un sujet dans une thématique
     * @param idSujet Sujet à supprimer
     * @param commentaire Commentaire sur la suppression (optionnel)
     * @param raison Identifiant de raison (optionnel)
     * @return Succès de l'opération
     */
    static deleteSubject(idSujet, commentaire, raison) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: ForumService.rubModule,
                    action: 'DELETE_SUBJECT',
                    idSujet,
                    raisonSuppression: raison,
                    commentaireSuppression: commentaire,
                },
            });
            return content;
        });
    }
    /**
     * Clôture d'un sujet dans une thématique
     * @param idSujet Sujet à clore/déverrouiller
     * @return Succès de l'opération
     */
    static closeSubject(idSujet) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idSujet }, {
                params: {
                    rub: ForumService.rubModule,
                    action: 'CLOSE_SUBJECT',
                },
            });
            return content;
        });
    }
    /**
     * Epingle un sujet dans une thématique
     * @param idSujet Sujet à épingler/désépingler
     * @return Succès de l'opération
     */
    static pinSubject(idSujet) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idSujet }, {
                params: {
                    rub: ForumService.rubModule,
                    action: 'PIN_SUBJECT',
                },
            });
            return content;
        });
    }
    /**
     * Ajout d'un like sur un message
     * @param idMessage Identifiant du message liké
     * @return Succès de l'opération
     */
    static addLike(idMessage) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idMessage }, {
                params: {
                    rub: ForumService.rubModule,
                    action: 'SAVE_LIKE',
                },
            });
            return content;
        });
    }
    /**
     * Suppression d'un like sur un message
     * @param idMessage Identifiant du message dont on souhaite enlever le like
     * @return Succès de l'opération
     */
    static deleteLike(idMessage) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: ForumService.rubModule,
                    action: 'DELETE_LIKE',
                    idMessage,
                },
            });
            return content;
        });
    }
    /**
     * Ajoute un suivi sur un sujet
     * @param urlSujet Lien du sujet à suivre
     * @return Succès de l'opération
     */
    static addFollow(urlSujet) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { urlSujet }, {
                params: {
                    rub: ForumService.rubModule,
                    action: 'SAVE_FOLLOW',
                },
            });
            return content;
        });
    }
    /**
     * Suppression d'un suivi sur un sujet
     * @param urlSujet Lien du sujet à ne plus suivre
     * @return Succès de l'opération
     */
    static deleteFollow(urlSujet) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: ForumService.rubModule,
                    action: 'DELETE_FOLLOW',
                    urlSujet,
                },
            });
            return content;
        });
    }
    /**
     * Ajoute un nouveau message à un sujet
     * @param message Message à ajouter
     * @return True si insertion réussie, false sinon
     */
    static addMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!message) {
                return null;
            }
            const { data: { content }, } = yield axiosInstance.post('/index.php', {
                message: message.toRaw(),
            }, {
                params: {
                    rub: ForumService.rubModule,
                    action: 'SAVE_MESSAGE',
                },
            });
            return content;
        });
    }
    /**
     * Supprime un message d'un sujet
     * @param message Message à supprimer
     * @return True si la suppression a réussie, false sinon
     */
    static deleteMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.delete('/index.php', {
                params: {
                    rub: ForumService.rubModule,
                    action: 'DELETE_MESSAGE',
                    idMessage: message.idForumMessage,
                },
            });
            return content;
        });
    }
    /**
     * Modifie un message
     * @param message Message à modifier
     * @return True si la modification a réussie, false sinon
     */
    static updateMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { message: message.toRaw() }, {
                params: {
                    rub: ForumService.rubModule,
                    action: 'UPDATE_MESSAGE',
                },
            });
            return content;
        });
    }
    /**
     * Passe un sujet suivi en lu
     * @param idSujet L'identifiant du sujet vu
     * @return True si l'opération a réussie, false sinon
     */
    static subjectSeen(idSujet) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { success }, } = yield axiosInstance.post('/index.php', { idSujet }, {
                params: {
                    rub: ForumService.rubModule,
                    action: 'SUBJECT_SEEN',
                },
            });
            return success;
        });
    }
    /**
     * Restaure un message du forum
     * @param message Message que l'on souhaite restaurer
     * @return Succès de l'opération
     */
    static restoreMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { content }, } = yield axiosInstance.post('/index.php', { idMessage: message.idForumMessage }, {
                params: {
                    rub: ForumService.rubModule,
                    action: 'RESTORE_MESSAGE',
                },
            });
            return content;
        });
    }
}
ForumService.rubModule = 'forum';
//# sourceMappingURL=data:application/json;base64,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